import styled from 'styled-components'
import { Row, Container } from '../generic/Layout'

import useTranslation from '../../hooks/useTranslation'

const CardBlock = styled.div`
    background: ${({theme}) => theme.card.background};
    width: 150px;
    height: 60px;
    margin-inline-end: 10px;
    padding: 0.5rem;
    font-size: var(--font-S);
    border-radius: 0.5rem 0.5rem ;
    box-shadow: ${({theme}) => theme.card.boxShadow};;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    &.active {
        background: ${({theme}) => theme.card.selected};
    }

    &:hover{
        background: ${({theme}) => theme.card.active};
    }

    @media (max-width: 768px) {
        background-color: transparent;
        width: auto;
        height: auto;
    }
`

const CountBadge = styled.span`
    background: ${({theme}) => theme.btn.primary};
    color: #fff;
    font-size: var(--font-XS);
    font-weight: 600;
    min-width: 1.25rem;
    height: 1.25rem;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.3rem;
    flex-shrink: 0;

    @media (max-width: 768px) {
        display: none;
    }
`

const ViewFilter = ({ filters, filter, setFilter, counts = {} }) => {
    // Guard: if filters are not provided or list is empty, render nothing
    if (!filters || !Array.isArray(filters.list) || filters.list.length === 0) return null;

    const marginTop = filters.marginTop || '0.5rem';
    const marginBottom = filters.marginBottom || '0.5rem';

    const { t } = useTranslation();
    return (
        <Container $marginTop={marginTop} $marginBottom={marginBottom}>
            <Row>
                {filters.list.map((f, i) => {
                    if (f?.showFilter === false) return null;
                    const isActive = filter !== undefined && filters.list[filter]?.label === f.label;
                    const count = counts[f.label]
                    return (
                        <CardBlock
                            id={f.label}
                            key={i}
                            className={isActive ? 'active' : 'inactive'}
                            onClick={() => setFilter(i)}
                            data-testid={`${f.label}`}
                        >
                            {t(f.label)}
                            {count != null && <CountBadge>{count}</CountBadge>}
                        </CardBlock>
                    );
                })}
            </Row>
        </Container>
    );
}

export default ViewFilter
